/**
 * This code is adapted from the zod-vue-i18n library
 * @see https://github.com/volverjs/zod-vue-i18n/blob/develop/src/utils/index.ts
 */

export function jsonStringifyReplacer(_: string, value: unknown): unknown {
  if (typeof value === "bigint") {
    return value.toString();
  }
  return value;
}
